import * as z from "../../../../framework";
import { PortalWidgetContainer } from "../../ui";

export var Widget = function (widgetInstance?) {
    widgetInstance = widgetInstance || {};
    widgetInstance.Widget = widgetInstance.Widget || {};

    var screen = widgetInstance.screen || new z.Screen(widgetInstance);

    this.widgetName = widgetInstance.Widget.WidgetName || "";
    this.title = widgetInstance.Widget.WidgetName;
    this.widgetElement = widgetInstance.widgetElement;
    this.id = `${(widgetInstance.Widget.Id || this.widgetName.replaceAll(" ", "_"))}_Instance${widgetInstance.Id}`;
    this.header = widgetInstance.Widget.Header || this.widgetName;
    this.widgetType = widgetInstance.Widget.WidgetType;
    this.widgetId = widgetInstance.WidgetId;
    this.options = this.parseOptions(widgetInstance);
    this.instanceId = widgetInstance.Id;
    this.custom = widgetInstance.custom;
    this.jsonView = widgetInstance.jsonView;
    this.gridOptions = widgetInstance.gridOptions || {};
    this.gridOptions.id = this.id;
    this.HTML = widgetInstance.HTML;

    $.extend(this, screen);
    z.screens[widgetInstance.Widget.WidgetName] = this;

    this.initWidget();
};

Widget.prototype = {
    // Pass ID here to retrieve widget
    initWidget: function () {
        var me = this;

        if (!me.custom) {
            var widgetView = new PortalWidgetContainer({
                id: "WidgetContainer",
                title: me.title,
                widgetName: me.widgetName,
                widgetType: me.widgetType,
                classes: "z-widget"
            });

            widgetView.options.zScreen = me;
            widgetView.render(me.widgetElement);
            var wContainer = me.get("#WidgetContainer");
            wContainer.data.title = me.title;

            wContainer.on("click", "span.k-i-arrow-chevron-down", function (e) {
                var contentElement = $(e.target).parents(".z-widget").find(".z-widget-contents");
                $(e.target)
                    .removeClass("k-i-arrow-chevron-down")
                    .addClass("k-i-arrow-chevron-up");

                kendo.fx(contentElement).expand("vertical").stop().play();
            });

            wContainer.on("click", "span.k-i-arrow-chevron-up", function (e) {
                var contentElement = $(e.target).parents(".z-widget").find(".z-widget-contents");
                $(e.target)
                    .removeClass("k-i-arrow-chevron-up")
                    .addClass("k-i-arrow-chevron-down");

                kendo.fx(contentElement).expand("vertical").stop().reverse();
            });
        }

        me.contents = me.get("#WidgetContainer").find(".z-widget-contents");
    },
    parseOptions: function (widgetInstance) {
        var widgetOptions, instanceOptions;

        try {
            widgetOptions = $.parseJSON(widgetInstance.Widget.Options);
        } catch (e) {
            widgetOptions = {};
        }

        try {
            instanceOptions = $.parseJSON(widgetInstance.Options);
        } catch (e) {
            instanceOptions = {};
        }

        return $.extend({}, widgetOptions, instanceOptions);
    }
};
